import React from "react";
import PropTypes from "prop-types";

function Heart({ size = "normal" }) {
  const isNormalSize = size === "normal";

  return (
    <svg
      width={isNormalSize ? "34" : "20"} 
      height={isNormalSize ? "30" : "18"} 
      viewBox="0 0 43 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.7427 5.19657C40.3501 2.67249 31.62 -5.77969 21.4999 6.4574C10.872 -5.77969 2.6472 2.67249 1.25707 5.19657C-1.27419 9.86383 0.244082 16.9298 3.78833 20.3362L21.5023 38L39.2163 20.3362C42.7557 16.9298 44.274 9.86625 41.7428 5.19657H41.7427Z"
        fill="#FF0101"
      />
    </svg>
  );
}

Heart.propTypes = {
  size: PropTypes.oneOf(["normal", "small"]),
};

export default Heart;
